export { UserGeneratedTranslations } from './UserGeneratedTranslations';
